import {
  docCodeConstants,
  docNameFromDocType,
  taskDocId,
} from "constants/documentCode";

export const generateDocCode = ({
  id,
  docType,
  docId,
  subDocId,
  isTask = true,
}) => {
  let tempId;
  if (!isTask) {
    tempId = id;
  } else {
    if (docType === taskDocId.catalogue) {
      tempId = subDocId;
    } else if (docType === taskDocId.misc) {
      tempId = id;
    } else {
      tempId = docId;
    }
  }
  const code = `${
    docCodeConstants[docNameFromDocType[docType]]?.prefix
  }_${tempId
    ?.toString()
    .padStart(
      docCodeConstants[docNameFromDocType[docType]]?.padSize,
      docCodeConstants[docNameFromDocType[docType]]?.pad
    )}${
    docCodeConstants[docNameFromDocType[docType]]?.suffix !== ""
      ? `_${docCodeConstants[docNameFromDocType[docType]]?.suffix}`
      : ``
  }`;
  return code;
};
export const docCodeGeneratorGlobal = ({ id, docType }) => {
  const code = `${docCodeConstants[docType]?.prefix}_${id
    ?.toString()
    .padStart(
      docCodeConstants[docType]?.padSize,
      docCodeConstants[docType]?.pad
    )}${
    docCodeConstants[docType]?.suffix !== ""
      ? `_${docCodeConstants[docType]?.suffix}`
      : ``
  }`;
  return code;
};
